import {
  CalendarMonth,
  FlightTakeoff,
  LocalOffer,
  Lock,
  People,
  ShoppingBasket,
  ShoppingCart
} from '@mui/icons-material'

import { AdminNavigationItem } from './AdminDashboard.types'

export const adminNavigationPaths = {
  users: 'users',
  externalBookings: 'external-bookings',
  offerRequests: 'offer-requests',
  readyToPurchase: 'ready-to-purchase',
  trips: 'trips',
  discountCodes: 'discount-codes',
  lockers: 'lockers'
}

export const adminNavigation: AdminNavigationItem[] = [
  {
    segment: adminNavigationPaths.users,
    title: 'Users',
    icon: <People />,
    pattern: 'users{/:userId}*'
  },
  {
    segment: adminNavigationPaths.offerRequests,
    title: 'Offer Requests',
    icon: <ShoppingCart />,
    pattern: 'offer-requests{/:userId}*'
  },
  {
    segment: adminNavigationPaths.readyToPurchase,
    title: 'Ready to Purchase',
    icon: <ShoppingBasket />
  },
  {
    segment: adminNavigationPaths.trips,
    title: 'Trips',
    icon: <FlightTakeoff />,
    pattern: 'trips{/:userId}*'
  },
  {
    segment: adminNavigationPaths.externalBookings,
    title: 'External Bookings',
    icon: <CalendarMonth />
  },
  {
    segment: adminNavigationPaths.discountCodes,
    title: 'Discount Codes',
    icon: <LocalOffer />
  },
  {
    segment: adminNavigationPaths.lockers,
    title: 'Lockers',
    icon: <Lock />
  }
]
